<template>
  <div class="navbar navbar-fixed-top" role="navigation">
    <div class="container">
      <div class="navbar-header">
        <a class="navbar-brand" :href="logoLink">
          <div class="logo"></div>
          <!--<img class="logo" :src="logo" alt="logo">-->
        </a>
      </div>
      <!--<div class="collapse navbar-collapse">-->
        <ul class="nav-item center">
          <li :class="active === 'home' ? 'active' : ''">
            <a :href="homeLink">Home</a>
          </li>
          <li>
            <a href="https://app.appsflyer.com/com.mico?pid=flatads_int&af_siteid=${AF_SITEID}&af_click_lookback=7d&clickid=${AUCTION_BID_ID}&advertising_id=${GAID}">Live</a>
          </li>
          <li>
            <a href="https://app.appsflyer.com/com.mico?pid=flatads_int&af_siteid=${AF_SITEID}&af_click_lookback=7d&clickid=${AUCTION_BID_ID}&advertising_id=${GAID}">
              <i class="hot"></i>
              Hot
            </a>
          </li>
          <!--<li v-if="showFeed" :class="active === 'hot' ? 'active' : ''"><a href="/hot">{{ text.hot_live }}</a></li>-->
        </ul>
        <ul class="nav-item last">
          <li>
            <a target="_blank" href="https://app.appsflyer.com/com.mico?pid=flatads_int&af_siteid=${AF_SITEID}&af_click_lookback=7d&clickid=${AUCTION_BID_ID}&advertising_id=${GAID}">
              <i class="app-icon"></i>
              <span>App</span>

              <!--<download-tooltip position="top" class="dt" />-->
            </a>
          </li>
        </ul>
      <!--</div>&lt;!&ndash;/.nav-collapse &ndash;&gt;-->
    </div>
    <template v-if="dialogShown">
      <div class="layui-layer-shade" id="layui-layer-shade1" times="1">
        <div class="content">
          <img src="/img/pink-alert.png">
          <a href="javascript:void(0);" @click="toOnelink()" class="btn"></a>
          <svg @click="closeDialog()" t="1670470464455" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3468" width="200" height="200"><path d="M649.179 512l212.839-212.84c37.881-37.881 37.881-99.298 0-137.179s-99.298-37.881-137.179 0L512 374.821l-212.839-212.84c-37.881-37.881-99.298-37.881-137.179 0s-37.881 99.298 0 137.179L374.821 512 161.982 724.84c-37.881 37.881-37.881 99.297 0 137.179 18.94 18.94 43.765 28.41 68.589 28.41 24.825 0 49.649-9.47 68.589-28.41L512 649.179l212.839 212.84c18.94 18.94 43.765 28.41 68.589 28.41s49.649-9.47 68.59-28.41c37.881-37.882 37.881-99.298 0-137.179L649.179 512z" p-id="3469"></path></svg>
        </div>
      </div>
      <!--<div class="layui-layer layui-layer-page prompt-alert" id="layui-layer1" type="page" times="1" showtime="0" contype="string">-->
        <!--<div id="" class="layui-layer-content">-->
          <!--<h3>Download MICO app in 30 seconds</h3>-->
          <!--<p>Download Mico and you might get a Lucky Bag</p>-->
        <!--</div>-->
        <!--<div class="layui-layer-btn layui-layer-btn-">-->
          <!--<a class="layui-layer-btn0" @click="toOnelink()">OK</a>-->
          <!--<a class="layui-layer-btn1" @click="closeDialog()">Cancel</a>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="layui-layer-move"></div>-->
    </template>
  </div>
</template>
<script>
  import DownloadTooltip from '../DownloadTooltip'
  export default {
    components: { DownloadTooltip },
    props: {
      active: {
        type: String,
        default: ''
      },
      apkLinkShown: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        showFeed: !!window.showFeed,
        language: {},
        languages: [],
        dialogShown: false,
        timer: 0
      }
    },
    watch: {
      dialogShown: function(n) {
        if (n) {
          document.documentElement.style.overflow = 'hidden'
          document.body.style.overflow = 'hidden'
        } else {
          document.documentElement.style.overflow = 'auto'
          document.body.style.overflow = 'auto'
        }
      }
    },
    computed: {
      homeLink() {
        return '/streams.html' + (location.search || '')
      },
      showRechargeButton() {
        return window.location.pathname !== '/' && !/(Mac|iPhone|iPod|iPad)/i.test(window.navigator.platform)
      },
      logoLink() {
        return '/streams.html' + (location.search || '')
      },
      text() {
        return window.text
      },
      logo() {
        if (window.location.href.match(/micotm/)) {
          return '//image.micoworld.net/e37f09b1081c084f1932de889c8e0ae5.png'
        } else {
          return '//image.micoworld.net/c4909704820d4ddaff4f5be140315162.png'
        }
      }
    },
    created() {
      this.languages = window.languages.filter((item) => {
        if(item.value === window.document.documentElement.lang) {
          this.language = item
        } else {
          return true
        }
      })
    },
    methods: {
      toOnelink() {
        location.href = 'https://app.appsflyer.com/com.mico?pid=flatads_int&af_siteid=${AF_SITEID}&af_click_lookback=7d&clickid=${AUCTION_BID_ID}&advertising_id=${GAID}'
      },
      closeDialog() {
        this.dialogShown = false
        clearTimeout(this.timer)
      }
    },
    mounted() {
      const img = new Image()
      img.src = '/img/fire_1f525.png'
      if (this.active !== 'home') {
        this.timer = setTimeout(() => {
          this.dialogShown = true
        }, 60000)
      }
      $("#micoLanguage").click(function() {
        $("#selectLan li").slideToggle("fast");
        $("#changeTriangle").toggleClass("triangleRotate");
      })

      //展示多语言弹框
      $(".languageBtn").click(function(){
        $(".languageList").slideToggle("slow");
      })
    },
    destroy() {
      clearTimeout(this.timer)
    }
  }
</script>
<style lang="less" scoped>
@import "./index";
</style>
<style lang="less">
  a,a:hover,a:active,a:visited,a:link,a:focus{
    -webkit-tap-highlight-color:rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
    outline:none;
    background: none;
    text-decoration: none;
  }
  .layui-layer-shade {
    display: flex;
    justify-content: center;
    align-items: center;

    .content {
      position: relative;
      width: 80vmin;

      img {
        width: 100%;
        border-radius: 2rem;
      }

      .btn {
        position: absolute;
        left: 12%;
        right: 12%;
        bottom: 18%;
        height: 20%;
      }

      svg {
        position: absolute;
        top: 1rem;
        right: 1rem;
        width: 3rem;
        height: 3rem;
      }
    }
  }

  .layui-layer-shade {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, .7);
  }
  a i.hot {
    display: inline-block;
    background: url("~@public/img/fire_1f525.png") no-repeat center/contain;
    width: 1em;
    height: 1em;
  }
</style>
